import { render, staticRenderFns } from "./MailSmsLegendText.vue?vue&type=template&id=b34d2834&"
import script from "./MailSmsLegendText.vue?vue&type=script&lang=js&"
export * from "./MailSmsLegendText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/MailSmsLegendText.vue
// module id = null
// module chunks = 